import { api } from '../../services/api';

const MERCHANDISING_URL = '/xmerchandising/';

export const getData = (filters) =>
  api.get(`${MERCHANDISING_URL}?${filters}`);
